import React, { Component } from 'react';

export default class PortalAccountFullDetailsUserTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      user_task_instruction_detail: null,
    };
    this.handleInfo = this.handleInfo.bind(this);
  }


  postData(url = ``, data = {}) {
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: JSON.stringify(data),
    }).
    then(
      response => response //=> response.json()
    );
  }
  handleInfo(event) {
    console.log(event.target.value);
    this.setState({user_task_instruction_detail: event.target.value});
  
  }

  handleJobUserTaskUpdate(job_id) {
    let selectedCompanyData = {
      api_token: window.api_token,
      job_id: job_id,
      user_id: this.props.data.id,
      user_task_special_instruction: this.state.user_task_instruction_detail
    };
    this.postData('/api/v1/portal/jobs/update-job-user-task-btn-from-portal', selectedCompanyData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          $('#infomodallabel').html('User task');
          $('#infomodal .modal-body').html('User task saved');
          $('#infomodal').modal();
        }
      }).
      catch(error => {
          $('#job-scheduler-modal').modal('modal');
        }
      );


      
  }

  renderUserTask() {
    let AccountNotifications = [];
    if (this.props.data.user_task.length > 0) {
      this.props.data.user_task.forEach((i) => {
        AccountNotifications.push(
          <div className="row" id="update-user-task-{i.user_job_id}">
            <div className="col-md-3">
              <div className="portal-admin-table-full-details-column-container">
                <h3>{i.user_job_id}</h3>
              </div>
            </div>
            <div className="col-md-6">
              <div className="portal-admin-table-full-details-column-container">
                <textarea className="form-control form-control-lg"  name="user_task_special_instruction"
                    id="user_task_special_instruction" rows='6' onChange={this.handleInfo}>{i.user_task_instruction_detail}</textarea>
              </div>
            </div>
            <div className="col-md-3">
              <div className="portal-admin-table-full-details-column-container">
                <button
                    className="btn btn-lg btn-primary"
                    onClick={() => {
                    this.handleJobUserTaskUpdate(
                     i.user_job_id
                    )}}
                    type="button">
                    <i className="fa fa-mobile">
                    </i>&nbsp;
                    Update UserTask 
                  </button>
              </div>
            </div>
          </div>
        );
      });
    }

    return AccountNotifications;
  }
  render() {
    return (
      <div
        className="portal-admin-table-row portal-account-full-details"
        id={"portal-account-full-details-"+this.props.data.id}
        key={"portal-account-full-details-"+this.props.data.id}
      >
        <div className="row">
          <div className="col-md-3">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Job Number</h3>
            </div>
          </div>

          <div className="col-md-6">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Special Instruction</h3>
            </div>
          </div>

          <div className="col-md-3">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Update</h3>
            </div>
          </div>
        </div>
          {this.renderUserTask()}
      </div>
    )
  }
}